import React, { FC, useState, useCallback, ChangeEvent } from 'react'
import styles from './Toggle.module.scss'
import { useId } from '@reach/auto-id'

type ToggleProps = {
  id?: string
  label: string
  on?: boolean
  disabled?: boolean
  value?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const Toggle: FC<ToggleProps> = ({ disabled, id, label, on = false, onChange, value }) => {
  const toggleId = useId(id)
  const [checked, setChecked] = useState(on)

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (disabled) return

      setChecked(event.target.checked)
      onChange && onChange(event)
    },
    [onChange, disabled],
  )

  return (
    <div className={styles.toggle}>
      <input
        id={toggleId}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        value={value}
      />
      <label htmlFor={toggleId}>
        <span>{label}</span>
      </label>
    </div>
  )
}

Toggle.displayName = 'Toggle'
